import { useQuery } from '@tanstack/react-query'
import { api, ApiError } from './api'

export type PartnerStatus = 'pending' | 'active' | 'suspended'

export type SocialLink = { label: string; url: string }

export type Partner = {
  id: string
  type: string
  slug: string
  displayName: string
  bio: string | null
  avatarUrl: string | null
  coverUrl: string | null
  countryCode: string | null
  websiteUrl: string | null
  tagline: string | null
  journalistType: string | null
  socialLinks: SocialLink[]
  verified: boolean
  status: PartnerStatus
  followersCount: number
  audioCount: number
  totalPlays: number
  createdAt: string
  user?: { locale: string | null }
}

export type PartnerResult = { state: 'partner'; partner: Partner } | { state: 'none' }

export function usePartner(enabled: boolean) {
  return useQuery<PartnerResult>({
    queryKey: ['me', 'partner'],
    enabled,
    queryFn: async () => {
      try {
        const partner = await api.get<Partner>('/partners/me')
        return { state: 'partner', partner }
      } catch (err) {
        if (err instanceof ApiError && err.status === 403) {
          return { state: 'none' }
        }
        throw err
      }
    },
  })
}
